/**
 * Subcategories Service
 * Business logic and API calls for subcategories
 */

import { BaseService } from './base.service'
import {
  Subcategory,
  CreateSubcategoryDTO,
  UpdateSubcategoryDTO,
  ID,
} from '../types'

export class SubcategoriesService extends BaseService {
  private readonly endpoint = '/api/subcategories'

  /**
   * Get all subcategories
   */
  async getAll(): Promise<Subcategory[]> {
    return this.get<Subcategory[]>(this.endpoint)
  }

  /**
   * Get subcategory by ID
   */
  async getById(id: ID): Promise<Subcategory> {
    return this.get<Subcategory>(`${this.endpoint}/${id}`)
  }

  /**
   * Get subcategories by category ID
   */
  async getByCategory(categoryId: ID): Promise<Subcategory[]> {
    return this.get<Subcategory[]>(`${this.endpoint}/by-category/${categoryId}`)
  }

  /**
   * Create subcategory
   */
  async create(data: CreateSubcategoryDTO): Promise<Subcategory> {
    return this.post<Subcategory, CreateSubcategoryDTO>(this.endpoint, data)
  }

  /**
   * Update subcategory
   */
  async update(id: ID, data: Partial<UpdateSubcategoryDTO>): Promise<Subcategory> {
    return this.put<Subcategory, Partial<UpdateSubcategoryDTO>>(
      `${this.endpoint}/${id}`,
      data
    )
  }

  /**
   * Delete subcategory
   */
  async delete(id: ID): Promise<void> {
    return this.delete<void>(`${this.endpoint}/${id}`)
  }
}

export const subcategoriesService = new SubcategoriesService()


